// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// IAaveEcosystemReserveController https://etherscan.io/address/0x3d569673dAa0575c936c7c67c4E6AedA69CC630C
export const AAVE_ECOSYSTEM_RESERVE_CONTROLLER = '0x3d569673dAa0575c936c7c67c4E6AedA69CC630C';

// https://etherscan.io/address/0x25F2226B597E8F9514B3F68F00f494cF4f286491
export const ECOSYSTEM_RESERVE = '0x25F2226B597E8F9514B3F68F00f494cF4f286491';

// https://etherscan.io/address/0x86C3FfeE349A7cFf7cA88C449717B1b133bfb517
export const PROXY_ADMIN_LONG = '0x86C3FfeE349A7cFf7cA88C449717B1b133bfb517';

// https://etherscan.io/address/0x3ea64b1C0194524b48F9118462C8E9cd61a243c7
export const AAVE_SWAPPER = '0x3ea64b1C0194524b48F9118462C8E9cd61a243c7';

// https://etherscan.io/address/0x1C2BA5b8ab8e795fF44387ba6d251fa65AD20b36
export const AAVE_POL_ETH_BRIDGE = '0x1C2BA5b8ab8e795fF44387ba6d251fa65AD20b36';

// https://etherscan.io/address/0xEB0682d148e874553008730f0686ea89db7DA412
export const TRANSPARENT_PROXY_FACTORY = '0xEB0682d148e874553008730f0686ea89db7DA412';

// https://etherscan.io/address/0xD3cF979e676265e4f6379749DECe4708B9A22476
export const PROXY_ADMIN = '0xD3cF979e676265e4f6379749DECe4708B9A22476';

// https://etherscan.io/address/0xcc3C54B95f3f1867A43009B80ed4DD930E3cE2F7
export const CREATE_3_FACTORY = '0xcc3C54B95f3f1867A43009B80ed4DD930E3cE2F7';

// https://etherscan.io/address/0x1cDF8879eC8bE012bA959EB515b11008E0cb6323
export const AAVE_CL_ROBOT_OPERATOR = '0x1cDF8879eC8bE012bA959EB515b11008E0cb6323';

// https://etherscan.io/address/0x2CFe3ec4d5a6811f4B8067F0DE7e47DfA938Aa30
export const PROTOCOL_GUARDIAN = '0x2CFe3ec4d5a6811f4B8067F0DE7e47DfA938Aa30';

// https://etherscan.io/address/0xa88c6D90eAe942291325f9ae3c66f3563B93FE10
export const AAVE_MERKLE_DISTRIBUTOR = '0xa88c6D90eAe942291325f9ae3c66f3563B93FE10';

// https://etherscan.io/address/0x197E90f9FAD81970bA7976f33CbD77088E5D7cf7
export const sDAI_POT = '0x197E90f9FAD81970bA7976f33CbD77088E5D7cf7';

// https://etherscan.io/address/0x004626A008B1aCdC4c74ab51644093b155e59A23
export const stEUR = '0x004626A008B1aCdC4c74ab51644093b155e59A23';

// https://etherscan.io/address/0xb4d5289C58CE36080b0748B47F859D8F50dFAACb
export const agEUR_EUR_AGGREGATOR = '0xb4d5289C58CE36080b0748B47F859D8F50dFAACb';

// https://etherscan.io/address/0xb49f677943BC038e9857d61E7d053CaA2C1734C1
export const EUR_USD_AGGREGATOR = '0xb49f677943BC038e9857d61E7d053CaA2C1734C1';

// https://etherscan.io/address/0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee
export const weETH_RATIO_PROVIDER = '0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee';

// https://etherscan.io/address/0x22740deBa78d5a0c24C58C740e3715ec29de1bFa
export const AFC_SAFE = '0x22740deBa78d5a0c24C58C740e3715ec29de1bFa';

// https://etherscan.io/address/0xA1c93D2687f7014Aaf588c764E3Ce80aF016229b
export const ALC_SAFE = '0xA1c93D2687f7014Aaf588c764E3Ce80aF016229b';

// https://etherscan.io/address/0xdef1FA4CEfe67365ba046a7C630D6B885298E210
export const MASIV_SAFE = '0xdef1FA4CEfe67365ba046a7C630D6B885298E210';

// https://etherscan.io/address/0xdeadD8aB03075b7FBA81864202a2f59EE25B312b
export const MERIT_AHAB_SAFE = '0xdeadD8aB03075b7FBA81864202a2f59EE25B312b';

// https://etherscan.io/address/0xAA43203167317DeeF8288095C44b84a686918d2E
export const APE_SAFE = '0xAA43203167317DeeF8288095C44b84a686918d2E';

// https://etherscan.io/address/0xa9e777D56C0Ad861f6a03967E080e767ad8D39b6
export const APE_VOTING_SAFE = '0xa9e777D56C0Ad861f6a03967E080e767ad8D39b6';

// https://etherscan.io/address/0xAAB6f926DCDaE536F54ce58478Dbc1a0d0f98871
export const ALC_INCENTIVE_SAFE = '0xAAB6f926DCDaE536F54ce58478Dbc1a0d0f98871';

// https://etherscan.io/address/0xAA484Ba6a7f51f00A3f82a11e73b741AE1dEAB58
export const ALC_VOTING_SAFE = '0xAA484Ba6a7f51f00A3f82a11e73b741AE1dEAB58';

// https://etherscan.io/address/0xCDb4fA6ba08bF1FB7Aa9fDf6002E78EDc431a642
export const FRONTIER_SAFE = '0xCDb4fA6ba08bF1FB7Aa9fDf6002E78EDc431a642';

// https://etherscan.io/address/0xAA870e4B82deaDa3727235f34183Ec9B728714C8
export const MERIT_INCENTIVE_SAFE = '0xAA870e4B82deaDa3727235f34183Ec9B728714C8';

// https://etherscan.io/address/0xAA2461f0f0A3dE5fEAF3273eAe16DEF861cf594e
export const AHAB_SAFE = '0xAA2461f0f0A3dE5fEAF3273eAe16DEF861cf594e';

// https://etherscan.io/address/0xAAd742dd9111373ec3C1E53b005e870d4CfF3be2
export const AHAB_INCENTIVES_SAFE = '0xAAd742dd9111373ec3C1E53b005e870d4CfF3be2';

// https://etherscan.io/address/0xAA12BAd4a501d45A5b771e49C2Fd415BA8BFc79d
export const AFC_CEX_EARN_SAFE = '0xAA12BAd4a501d45A5b771e49C2Fd415BA8BFc79d';

// https://etherscan.io/address/0xaa7A1910BA79B6A2E385ebA26185aA2dCB9B8eAd
export const AFC_CEX_EARN_INCENTIVE_SAFE = '0xaa7A1910BA79B6A2E385ebA26185aA2dCB9B8eAd';

// https://etherscan.io/address/0x2C7f01A1322ce99EEB331d6Eb73Aff400f11C5CB
export const REWARD_STEWARD = '0x2C7f01A1322ce99EEB331d6Eb73Aff400f11C5CB';

// https://etherscan.io/address/0x95E3015c67EF62B866cC28ca5A9AB5017A55e336
export const AGENT_HUB = '0x95E3015c67EF62B866cC28ca5A9AB5017A55e336';

// https://etherscan.io/address/0x5CFc96c396325724D49dfF95Da103feDdbf48E05
export const AGENT_HUB_AUTOMATION = '0x5CFc96c396325724D49dfF95Da103feDdbf48E05';

// https://etherscan.io/address/0x9240a6669CC4782FC98620212862DF5CB2e0Df10
export const RANGE_VALIDATION_MODULE = '0x9240a6669CC4782FC98620212862DF5CB2e0Df10';

export const CHAIN_ID = 1;
